import SectorsTab from './SectorsTab';

export default SectorsTab;
